import * as Constants from "../common/Constants";

const initialState = {
    users: [],
    user: null,
    branch:null,
    systemRoles: [],
    changePassword: {},
    currentUser: {},
    filteredUsers: [],
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function userReducer(state = initialState, action) {

    switch (action.type) {
        case Constants.REQUEST_ADD_USER:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.REQUEST_GET_USER:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_ADD_USER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;
        case Constants.SUCCESS_FILTERED_USER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.FAILED_ADD_USER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_CURRENT_USER:
            
            var newState = { ...state };
            var newState = { ...state };
            newState.error = null;
            newState.isLoading = true;

        case Constants.FAILED_CURRENT_USER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.RECEIVE_CURRENT_USER:
            
            var newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            newState.currentUser = action.payload;
            return newState;

        case Constants.SUCCESS_GET_USER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.users = action.params.items;
            newState.page = action.params.page;
            newState.pageSize = action.params.pageSize;
            newState.count = action.params.totalCount;
            return newState;

        case Constants.REQUEST_CHANGE_PASSWORD:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.FAILED_CHANGE_PASSWORD:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_CHANGE_PASSWORD:
            
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            newState.changePassword = action.payload;
            return newState;

        case Constants.REQUEST_ADD_TO_USER_ROLE:
            newState = { ...state };
            newState.isLoading = true;
            newState.isPosted = false;
            newState.error = null;
            return newState;

        case Constants.SUCCESS_ADD_TO_USER_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_ADD_TO_USER_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js